const GLOBAL_FILTER_RESET = '[GLOBAL]FILTER_RESET';
const MANUAL_AREA_CHANGE = '[GLOBAL]/MANUAL_AREA_CHANGE';

export const INITIAL_QUERY = 'app/INITIAL_QUERY';
export const INITIAL_QUERY_SUCCESS = 'app/INITIAL_QUERY_SUCCESS';
export const INITIAL_QUERY_FAIL = 'app/INITIAL_QUERY_FAIL';
export const APP_SEARCH_QUERY_SUCCESS = 'app/SEARCH_QUERY_SUCCESS';

export { MANUAL_AREA_CHANGE, GLOBAL_FILTER_RESET };
